// extracted by mini-css-extract-plugin
module.exports = {"title":"components-module__title___2fivY","large":"components-module__large___3J5Jc","date":"components-module__date___3536o","button":"components-module__button___39XKR"};